<template lang="pug">
.mg-game__superprize
  span.mg-game__superprize__label {{ $t('game.superprize') }}
  .mg-item
    img(:src="getPrizeImgSrc")
    .mg-item__info(name="tooltip_superprize") i

    tippy(to="tooltip_superprize", theme="item")
      ItemTooltip(:itemContent="getPrizesList.superprize.contents[0].content")

  span.mg-game__superprize__count.mg-game__superprize__count--received(v-if="getSuperprizeClaimedAmount === getSuperprizeLimit") {{ $t('game.received') }}
  span.mg-game__superprize__count(v-else) {{ getCardsList.superprize }} / {{ getMaxShardsCount }}
</template>

<script>
import ItemTooltip from "@chronos/frontend-base/src/components/tooltip/la/ItemTooltip";
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapGetters } = createNamespacedHelpers(mg_global);

export default {
  name: "GameSuperprize",

  components: {
    ItemTooltip,
  },

  computed: {
    ...mapGetters([
      "getPrizesList",
      "getCardsList",
      "getMaxShardsCount",
      "getSuperprizeLimit",
      "getSuperprizeClaimedAmount",
    ]),

    getPrizeImgSrc() {
      return this.getPrizesList.superprize.offer.images.preview ? this.getPrizesList.superprize.offer.images.preview : require(`@/assets/game/images/prizes/default.png`);
    },

    getSuperprizeText() {
      return this.$t("game.superprize_text");
    },
  },
};
</script>
